import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getNotFoundPath = () => urlHelper('/not-found');
